import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOrganisation } from "../../../utilities/Interfaces/OrganisationInterfaces";

/**
 * Authentication state declaration
 */
export interface OrganisationState {
  organisations: IOrganisation[],
  
}

/**
 * Initial authentication state definition
 */
const initialState: OrganisationState = {
    organisations: [],
    
};

/**
 * Authentication slice combining actions and reducer
 */
export const organisationSlice = createSlice({
  name: "organisation",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetOrganisations: (state) => {
      state.organisations = [];
    },
    setOrganisations: (state, action: PayloadAction<IOrganisation[]>) => {
      state.organisations = action.payload;
    },
    
  },
});

export const { resetOrganisations, setOrganisations } =
  organisationSlice.actions;


export default organisationSlice.reducer;